<div class="formOuterWrapper" id="contactDetails">
    <div class="container">
        <div class="row">
            <div class="col-lg-4">
                <div class="formInformationTxt">
                    <div class="formHeader">
                        <div class="contactInformation">
                            <h3>4.3/5.0</h3>
                        </div>
                        <div class="stars">
                            <i class="fa fa-star"></i>
                            <i class="fa fa-star"></i>
                            <i class="fa fa-star"></i>
                            <i class="fa fa-star"></i>
                            <i class="fa fa-star"></i>
                        </div>
                        <p>by 70+ customers for 100+ clients</p>
                    </div>
                    <div class="contactList">
                        <span><i class="fa fa-phone"></i></span>
                        <div class="contactDetails">    
                            <h6>Contact Us</h6>
                            <p>+91 09579482875</p>
                        </div>
                    </div>
                    <div class="contactList">
                        <span><i class="fa fa-envelope"></i></span>
                        <div class="contactDetails">    
                            <h6>Say hello</h6>
                            <p>contact@lottechnologies.in</p>
                        </div>
                    </div>
                    <div class="contactList">
                        <span><i class="fa fa-map-marker"></i></span>
                        <div class="contactDetails">    
                            <h6>Location</h6>
                            <p>Casa Rio Gold, Palava City, Dombivali East, Thane, Mumbai - 421204</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-8">
                <div class="formInnerWrapper">
                    <form #contactForm="ngForm" novalidate >
                        <!-- {{contactForm.value | json}} -->
                        <div class="basicDetails">
                            <input type="text" placeholder="Full Name*" #fullName="ngModel" name="fullName" ngModel required>
                        </div>
                        <div class="basicDetails">
                            <input type="text" placeholder="Email Id*" ngModel name="emailId" #emailId="ngModel" required>
                        </div>
                        <div class="selectBox" >
                            <select ngModel name="selectBox" #selectBox="ngModel">
                                <option value="" selected>Select Category</option>
                                <option value="Product_Development" >Product Development</option>
                                <option value="General_Information_Request" >General Information Request</option>
                                <option value="Admin_HR" >Admin & HR</option>
                                <option value="Careers" >Careers</option>
                            </select>
                        </div>
                        <div class="descriptionTxt">
                            <textarea placeholder="Please describe what you need." ngModel name="descriptionTxt" #descriptionTxt="ngModel"></textarea>
                        </div>
                        <div class="msgButton">
                            <input type="submit" value="Send message">
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>